import { type IFormAugmentedContext } from '@framework/form/form/augmented/FormAugmentedContext.tsx';
import { type UseFormReturn } from 'react-hook-form';
import { getSearchableFieldNames } from '../../getSearchableFieldNames.ts';
import { type SearchableField } from '../../ISearchableField.tsx';

export interface RemoveSearchableFieldOptions {
  field: SearchableField;
  methods: UseFormReturn;
  augmented: IFormAugmentedContext;
}

/**
 * `unregister` dei field name + submit per ri-fetchare con la nuova query.
 *
 * Rimozioni rapide di più filtri NON causano race: ogni submit produce una
 * `queryKey` unica (vedi `__cacheInvalidator` in `handleSearch`), quindi
 * eventuali risposte GET fuori ordine finiscono in slot di cache orfane e non
 * sovrascrivono i dati correnti.
 */
export function removeSearchableField({
  field,
  methods,
  augmented,
}: RemoveSearchableFieldOptions): void {
  methods.unregister(getSearchableFieldNames(field));
  augmented.submitForm.current?.();
}
